// Helpers for URLs coming from subject documents (AI output stored in Firestore): treat them as untrusted.

/** Parses `value` and returns it only if it's an https URL with a host, otherwise null (javascript:, data:, tel:...). */
export const safeWebURL = (value: unknown): URL | null => {
    if (typeof value !== 'string') return null;

    try {
        const url = new URL(value);
        return url.protocol === 'https:' && url.hostname !== '' ? url : null;
    } catch {
        return null;
    }
};

/** Whether the host is `domain` or one of its subdomains (e.g. "www.amazon.com" for "amazon.com"). */
export const hostMatches = (url: URL, domain: string): boolean => {
    const host = url.hostname.toLowerCase();
    return host === domain || host.endsWith(`.${domain}`);
};
